<template>
  <div class="wrapper center-text">
    <h2 class="top-padding">OUR HONEY</h2>
    <img :src="whiteLid" class="bottom-padding"/>
    <p class="informational-text larger-info-text" style="margin-bottom: 2.5rem;">Not all honey is created the same, Wero Mānuka honey is famous for its quality taste<span class="wrap-together"> and high MGO content</span></p>
    <span class="wrap-together">
      <i class="pi pi-check" style="font-size: 1.2rem; color: green; font-weight: 800; margin-right: 0.1rem"></i><span class="informational-text larger-info-text" style="margin-right: 1rem; font-size: 1.1rem">MONOFLORAL</span>
    </span>
    <span class="wrap-together">
      <i class="pi pi-check" style="font-size: 1.2rem; color: green; font-weight: 800; margin-right: 0.1rem"></i><span class="informational-text larger-info-text" style="margin-right: 1rem; font-size: 1.1rem">PREMIUM SUPERFOOD</span>
    </span>
    <span class="wrap-together">
      <i class="pi pi-check" style="font-size: 1.2rem; color: green; font-weight: 800; margin-right: 0.1rem"></i><span class="informational-text larger-info-text" style="margin-right: 1rem; font-size: 1.1rem">MADE IN NZ</span>
    </span>
    <span class="wrap-together">
      <i class="pi pi-check" style="font-size: 1.2rem; color: green; font-weight: 800; margin-right: 0.1rem"></i><span class="informational-text larger-info-text" style="margin-right: 1rem; font-size: 1.1rem">ACCREDITED INDEPENDENT TESTING</span>
    </span>

  </div>
</template>

<script>
export default {
  name: 'TopSection',

  props: {

  },

  mounted() {

  },

  data() {
    return {
      whiteLid: require("../../assets/images/white lid.png"),
    }
  },

  methods: {

  },

  computed: {
    vuex: function(){
      return(this.$store.state);
    },

  },

  watch: {

  }

}

</script>


<style scoped>

.wrapper{
  padding-bottom: 2rem;
}

  .larger-info-text{
    font-weight: 700;
    font-size: 1.4rem;
  }
  /* prevent wrapping of single or small word sentence*/
  span.wrap-together {
    white-space: nowrap ;
  }
</style>


